module.exports = __webpack_public_path__ + "img/ai.806be6a6.webp";